var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center",staticStyle:{"height":"100%"}},[(_vm.onePs.linkedin_url == 'loading' && _vm.onePs.is_linkedin_employees_fetch != 1)?_c('div',{staticClass:"sloader"}):_c('div',[(
				_vm.onePs.linkedin_url &&
				_vm.onePs.linkedin_url != 'loading' &&
				['https', 'http', 'www', 'linkedin'].some((el) =>
					_vm.onePs.linkedin_url.includes(el)
				)
			)?_c('div',{attrs:{"text":_vm.onePs.linkedin_url}},[_c('a',{attrs:{"target":"_blank","href":_vm.onePs.linkedin_url}},[_c('feather-icon',{staticClass:"m-0 cursor-pointer",staticStyle:{"color":"#0a66c2"},attrs:{"icon":"LinkedinIcon"}})],1)]):_c('div',[_vm._v("-")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }